import { ALLOWED_MIME_TYPES } from './assets.constants';

export const SUGGEST_CONTENT_FILE_FORMATS: string[] = [
  ALLOWED_MIME_TYPES.pdf,
  ALLOWED_MIME_TYPES.doc,
  ALLOWED_MIME_TYPES.docx,
  'text/plain',
  ALLOWED_MIME_TYPES.csv,
  ALLOWED_MIME_TYPES.xlsx,
];

export const SUGGEST_CONTENT_IMAGE_FORMATS: string[] = [
  ALLOWED_MIME_TYPES.png,
  ALLOWED_MIME_TYPES.jpg,
  ALLOWED_MIME_TYPES.gif,
  'image/svg+xml',
];
